module.exports = __webpack_public_path__ + "img/light.aec04882.svg";